import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CsatService {
    private readonly csatEnabled$ = new BehaviorSubject<boolean>(false);

    public enableCsat(isEnabled: boolean): void {
        this.csatEnabled$.next(isEnabled);
    }

    public csatEnabled(): Observable<boolean> {
        return this.csatEnabled$.asObservable();
    }
}
